import { render, staticRenderFns } from "./expiry.vue?vue&type=template&id=29800b84&"
import script from "./expiry.vue?vue&type=script&lang=ts&"
export * from "./expiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports